import partySeasonLook4Hero from "@/assets/images/journal/party-season-look-4-hero.png";
import partySeasonLook4Back from "@/assets/images/journal/party-season-look-4-back.jpg";

const journalImageUrls = {
  "party-season-look-4-hero": partySeasonLook4Hero,
  "party-season-look-4-back": partySeasonLook4Back,
};

function resolveJournalImages(value) {
  if (typeof value === "string" && journalImageUrls[value]) {
    return journalImageUrls[value];
  }

  if (Array.isArray(value)) {
    return value.map(resolveJournalImages);
  }

  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, child]) => [
        key,
        resolveJournalImages(child),
      ])
    );
  }

  return value;
}

export function loadContentJson(contentPath) {
  try {
    return require(`@/content/${contentPath}.json`);
  } catch (error) {
    try {
      return resolveJournalImages(
        require(`@/content/journal/${contentPath}.json`)
      );
    } catch (journalError) {
      return require(`@/content/brand-world/${contentPath}.json`);
    }
  }
}

export function slotElementProps(element) {
  if (!element?.props) {
    return {};
  }

  const domProps = { ...element.props };
  delete domProps.text;
  delete domProps.html;

  return domProps;
}

export function slotElementText(element) {
  if (!element) {
    return "";
  }

  if (typeof element.text === "string") {
    return element.text;
  }

  if (typeof element.props?.text === "string") {
    return element.props.text;
  }

  return "";
}
